import styled from 'styled-components';

// `Card` lives in its own dependency-free file because both
// surveyTheme.styles.js and surveyFieldTheme.styles.js need it (the latter's
// QuestionCard extends it) — putting it in either of those two would make
// them import each other, a circular import that throws "Cannot access 'X'
// before initialization" at runtime once webpack's module order shifts.
export const Card = styled.div`
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(249, 246, 241, 0.92) 100%);
  border: 1px solid rgba(216, 184, 137, 0.2);
  border-radius: 22px;
  padding: 1.5rem;
  margin-bottom: 1.25rem;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.05);

  body.dark-mode & {
    background: var(--background-secondary);
  }

  @media (max-width: 768px) {
    padding: 1.125rem;
    border-radius: 18px;
  }
`;
